var map = {
	"./11.svg": 6332,
	"./12.svg": 8655,
	"./13.svg": 2254,
	"./14.svg": 9633,
	"./15.svg": 8512,
	"./16.svg": 7907,
	"./17.svg": 4594,
	"./18.svg": 2501,
	"./21.svg": 8725,
	"./22.svg": 5766,
	"./23.svg": 5303,
	"./24.svg": 7704,
	"./25.svg": 9449,
	"./26.svg": 3450,
	"./27.svg": 9067,
	"./28.svg": 3180,
	"./31.svg": 5414,
	"./32.svg": 1637,
	"./33.svg": 3620,
	"./34.svg": 1979,
	"./35.svg": 6714,
	"./36.svg": 8649,
	"./37.svg": 3144,
	"./38.svg": 6031,
	"./41.svg": 2383,
	"./42.svg": 9708,
	"./43.svg": 2829,
	"./44.svg": 8898,
	"./45.svg": 3539,
	"./46.svg": 2848,
	"./47.svg": 8385,
	"./48.svg": 1142,
	"./coroa.svg": 7546,
	"./extracao.svg": 811,
	"./implante.svg": 6416,
	"./quadrado_anatomico.svg": 6483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9948;